const NS_MAPS = 'cisview_job_';

export const SET_GLOBAL_ASSISTING_DP = `${NS_MAPS}SET_GLOBAL_ASSISTING_DP`;
export const setGlobalAssistingDP = assistingDP => {
	return {
		type: SET_GLOBAL_ASSISTING_DP,
		payload: { assistingDP }
	};
};
